import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import { getStats } from "../Game.helpers";
import { useEffect, useState } from "react";


export interface FAQProps {
    open :boolean,
    handleClose: ()=>void
}

export interface Stats {
  visitor:string,
  correct:string,
  wrong:string
}

const StatsDialog = ({open, handleClose}: FAQProps) =>  {
  const [stats, setStats] = useState<Stats|null>(null)

  const getGlobalStats =async ():Promise<void> =>{
    const stats = await getStats()
    setStats(stats)
  }

  useEffect(()=>{
        getGlobalStats()
    },[])
    
    return (<Dialog open={open} onClose={handleClose}>
        <DialogTitle variant="h5">Global Stats</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="h6">
              Here's how other players have done:
            </Typography>
            <Typography variant="h6">{stats?.visitor} games played</Typography>
            <Typography variant="h6">{stats?.correct} correct guesses </Typography>
            <Typography variant="h6">{stats?.wrong} wrong guesses</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Okay, I got it</Button>
        </DialogActions>
      </Dialog>
      )
  }
      
export default StatsDialog